import { Guide, PageHandle, Section } from '../logic/Guide'
import { PageDescriptor } from '../pages/types'
import { PageViewerToolbar } from './PageViewerToolbar'

type PageViewerProps = {
    guide: Guide
    page: PageDescriptor
    section: Section
    print?: boolean
    onNavigate: (target?: PageHandle) => void
}

const PageViewer = ({ page, guide, section, print, onNavigate } : PageViewerProps) =>
    {
        const handle = { section: section.key, page: page.key }        
        const toolbar = !print && <PageViewerToolbar guide={guide} onNavigate={onNavigate} handle={handle}/>
        return <article>
            {print ? <h2>{page.title}</h2> : <h1>{page.title}</h1>}
            {page.render()}            
            {toolbar}            
        </article>
    }

export default PageViewer